import React, { useState } from 'react';
import { Button } from '../../shared';
import { MessageSquare, Send } from 'lucide-react';

export function FeedbackForm({ onSubmit, onCancel, language = 'th' }) {
    const [content, setContent] = useState('');
    const [category, setCategory] = useState('general');
    const [author, setAuthor] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!content.trim()) return;

        setSubmitting(true);
        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 800));

        onSubmit({
            author: author.trim() || undefined,
            content,
            category,
            createdAt: new Date().toISOString()
        });
        setSubmitting(false);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label className="block text-sm font-medium text-neutral-700 mb-1">
                    {language === 'th' ? 'หัวข้อ' : 'Category'}
                </label>
                <select
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    className="w-full px-3 py-2 rounded-lg border border-neutral-200 focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500 outline-none transition-all"
                >
                    <option value="general">{language === 'th' ? 'ทั่วไป' : 'General'}</option>
                    <option value="suggestion">{language === 'th' ? 'ข้อเสนอแนะ' : 'Suggestion'}</option>
                    <option value="issue">{language === 'th' ? 'แจ้งปัญหา' : 'Report Issue'}</option>
                </select>
            </div>

            <div>
                <label className="block text-sm font-medium text-neutral-700 mb-1">
                    {language === 'th' ? 'ชื่อของคุณ (ไม่บังคับ)' : 'Your Name (Optional)'}
                </label>
                <input
                    type="text"
                    value={author}
                    onChange={(e) => setAuthor(e.target.value)}
                    className="w-full px-3 py-2 rounded-lg border border-neutral-200 focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500 outline-none transition-all"
                    placeholder={language === 'th' ? 'เช่น สายกิน' : 'e.g. Foodie123'}
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-neutral-700 mb-1">
                    {language === 'th' ? 'ข้อความ' : 'Message'}
                </label>
                <textarea
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    rows={4}
                    className="w-full px-3 py-2 rounded-lg border border-neutral-200 focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500 outline-none transition-all resize-none"
                    placeholder={language === 'th' ? 'พิมพ์ข้อความของคุณที่นี่...' : 'Type your message here...'}
                    required
                />
            </div>

            <div className="flex gap-2 pt-2">
                <Button variant="secondary" onClick={onCancel} type="button" fullWidth>
                    {language === 'th' ? 'ยกเลิก' : 'Cancel'}
                </Button>
                <Button variant="primary" type="submit" loading={submitting} fullWidth icon={<Send size={14} />}>
                    {language === 'th' ? 'ส่ง' : 'Send'}
                </Button>
            </div>
        </form>
    );
}
